<template>
  <div id="adminLinguas">
    <p>Use #ask code to print</p>
    <div class="tabs-langs">
      <b-tabs content-class="mt-3">
        <b-tab @click="traducoesFN(dt)" :title="dt" v-for="(dt, index) in linguas" :key="index" :active="sel === dt">

          <div class="form-group" v-for="(dt, index) in traducoes" :key="index">
            <input v-model="dt.p" type="text" class="form-control" placeholder="Question">
            <textarea v-model="dt.r" class="form-control" placeholder="Answer"></textarea>
            <button class="btn btn-pure text-danger m-t-10 float-right" @click="delTraducao(index)"><i class="fas fa-trash"></i></button>
            <div class="clearfix"></div>
            <hr />
          </div>
          <div class="clearfix"></div>
          <button type="button" @click="traducoes.push({p: '', r: ''})" class="btn btn-warning float-left m-t-10">Add question</button>
          <button type="button" @click="submitTrad" class="btn btn-primary float-right m-t-10">UPDATE</button>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'adminLinguas',
  data () {
    return {
      linguas: [],
      sel: '',
      traducoes: []
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.SET_TITULO('Common Questions')
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_TOAST',
      'SET_AVISO',
      'SET_OPTIONS',
      'SET_LOAD1'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.user1) {
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.linguas = JSON.parse(this.$store.state.option.langs)
        this.sel = this.linguas[0]
        if (this.$store.state.option['ask-' + this.sel]) {
          this.traducoes = JSON.parse(this.$store.state.option['ask-' + this.sel])
        } else {
          this.traducoes = [{ p: '', r: '' }]
        }
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    },
    // traducoes
    submitTrad () {
      this.SET_LOAD1(true)
      let dta = this.$store.state.option
      dta['ask-' + this.sel] = JSON.stringify(this.traducoes)
      this.axios.post('/options', dta).then((res) => {
        this.SET_TOAST({ msg: 'Updated successfully' })
        this.SET_OPTIONS(res.data)
        if (res.data['ask-' + this.sel]) {
          this.traducoes = JSON.parse(res.data['ask-' + this.sel])
        } else {
          this.traducoes = [{ p: '', r: '' }]
        }
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    delTraducao (index) {
      this.traducoes.splice(index, 1)
    },
    traducoesFN (dt) {
      this.sel = dt
      if (this.$store.state.option['ask-' + dt]) {
        this.traducoes = JSON.parse(this.$store.state.option['ask-' + dt])
      } else {
        this.traducoes = [{ p: '', r: '' }]
      }
    }
  }
}
</script>
